import React from "react";
import { connect } from "react-redux";
import { object, func, string } from "prop-types";
import { Button, Dropdown, Modal } from "react-bootstrap";
import checkrIcon from "../../../resources/images/Checkr_Logo_100px.png";
import { getCheckrPackages, checkrInviteCandidate } from "../actions";

export class BackgroundCheck extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      packageChosen: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.onGetCheckrPackages();
  }

  handleChangeAction = () => {
    this.props.changeAction(false);
  };

  handleChoosePackage = (packageName) => {
    this.setState({ packageChosen: packageName });
  };

  handleBackgroundCheckSubmit = () => {
    const internal = this.props.userData && this.props.userData.internal;
    if (this.state.packageChosen) {
      this.props.onCheckrInviteCandidate(
        this.props.currentCandidateId,
        this.state.packageChosen,
        internal
      );
      this.handleChangeAction();
    }
  };

  render() {
    const { checkrPackages } = this.props;

    const CheckrPackagesMenuItems = [];
    checkrPackages.keySeq().forEach((packageName) => {
      CheckrPackagesMenuItems.push(
        <Dropdown.Item key={packageName} eventKey={packageName}>
          {checkrPackages.get(packageName).get("name")}
        </Dropdown.Item>
      );
    });

    return (
      <div>
        <Modal.Header>
          <h4>
            <img src={`${checkrIcon}`} alt="Checkr" />
          </h4>
        </Modal.Header>
        <Modal.Body>
          <p>
            You are about to request a background check for:{" "}
            <strong>{this.props.candidateName}</strong>
          </p>
          <p>
            <strong>Choose a Checkr report:</strong>
          </p>
          <div>
            <Dropdown
              onSelect={this.handleChoosePackage}
              id="checkr_reports_dropdown"
            >
              <Dropdown.Toggle variant="outline-secondary">
                {checkrPackages.size > 0 &&
                checkrPackages.get(this.state.packageChosen)
                  ? checkrPackages.get(this.state.packageChosen).get("name")
                  : "Select a package"}
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{ maxHeight: "300px", overflowY: "scroll" }}
              >
                {CheckrPackagesMenuItems}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleChangeAction}
            id="cancelBackgroundCheck"
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleBackgroundCheckSubmit}
            disabled={!this.state.packageChosen}
            id="requestBackgroundCheck"
          >
            Request Background Check
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

BackgroundCheck.propTypes = {
  checkrPackages: object,
  changeAction: func,
  currentCandidateId: string,
  candidateName: string,
  onGetCheckrPackages: func,
  onCheckrInviteCandidate: func,
  userData: object,
};

const mapStateToProps = (state) => ({
  checkrPackages: state.get("results").get("checkrPackages"),
  userData: state.get("App").get("userData"),
});

const mapDispatchToProps = (dispatch) => ({
  onGetCheckrPackages: () => dispatch(getCheckrPackages()),
  onCheckrInviteCandidate: (testTakerId, checkrPackage, internal) =>
    dispatch(checkrInviteCandidate(testTakerId, checkrPackage, internal)),
  dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheck);
